import React from "react";
import {
  MANAGER_ADD_PATH,
  MANAGER_UPDATE_PATH,
  MANAGERS_PATH,
} from "utils/constants/paths";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";

const Managers = Loadable(React.lazy(() => import("./View")));
const ManagersAddOrUpdate = Loadable(React.lazy(() => import("./View/Detail")));

export const ManagersRoute: IRouteItem = {
  path: MANAGERS_PATH,
  iconName: "Profile",
  element: React.createElement(Managers),
  name: "Managers",
  accessKeys: ["SuperAdmin", "Admin"],
  children: [
    {
      name: "Detail",
      path: MANAGER_ADD_PATH,
      element: React.createElement(ManagersAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: MANAGER_UPDATE_PATH,
      element: React.createElement(ManagersAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
